import "./style.scss";

const UseGoodsSwiper = (props: Types.Cons.IGoodsListList) => {
  let { goodsList, setGoodsID, goodsID } = props;

  // 选中 id
  const goodsListChecked = (row: Types.Http.IGoodsRes) => {
    if (setGoodsID) {
      setGoodsID(String(row.goods_id));
    }
    // console.log("row =>", row);
  };

  return (
    <div className="goods-box">
      <div className="wrap___M0MqH">
        <div className="goods-icon-center">
          {goodsList.map((item: Types.Http.IGoodsRes) => {
            return (
              <div
                className="goods-icon-box"
                key={item.goods_id}
                onClick={() => goodsListChecked(item)}
              >
                <img src={item.image} alt="" className="goods-icon" />
                <p className="goods-name">{item.goods_name}</p>

                {item.goods_id === Number(goodsID) ? (
                  <img src={item.bg_goods_selected} className="selected" />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default UseGoodsSwiper;
